import { Component, OnInit } from '@angular/core';
import { AppCommonModule } from '../app-common.module';

@Component({
	standalone: true,
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
	imports: [AppCommonModule],
})
export class PageNotFoundComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
